import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import normalize from "../utils/NormalizeSelect";

const INHERIT = "__inherit__";

const DriverPricingSelect = ({
    value,
    onChange,
    allowInherit = true,
    inheritLabel = "Use default",
    label = "Driver Pricing Model",
    error = "",
    required = false,
    isDisabled = false,
}) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem("token");

    useEffect(() => {
        let cancelled = false;

        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}driver-pricing/list`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                if (cancelled) return;
                if (res.data.code === 1) {
                    const fetched = (res.data.data || []).map((item) => ({
                        label: item.label,
                        value: String(item.value),
                    }));
                    setOptions(
                        allowInherit
                            ? [{ label: inheritLabel, value: INHERIT }, ...fetched]
                            : fetched,
                    );
                }
            })
            .catch(console.error)
            .finally(() => {
                if (!cancelled) setIsLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [allowInherit, inheritLabel, token]);

    const selected =
        options.find(
            (option) =>
                option.value === (value ? String(value) : allowInherit ? INHERIT : ""),
        ) ?? null;

    return (
        <div className="fv-row fv-plugins-icon-container">
            <label className={`form-label ${required ? "required" : ""}`}>
                {label}
            </label>
            <Select
                className="react-select-styled react-select-bordered"
                classNamePrefix="react-select"
                value={selected}
                options={options}
                isLoading={isLoading}
                isDisabled={isDisabled}
                onChange={(option) =>
                    onChange(!option || option.value === INHERIT ? null : option.value)
                }
                filterOption={(option, input) =>
                    normalize(option.label).includes(normalize(input))
                }
                placeholder="Select a driver pricing model"
            />
            <small className="text-danger mt-2">{error}</small>
        </div>
    );
};

export default DriverPricingSelect;